
<template>
	<div ref="landingPage" class="relative w-full h-[95vh] grid place-content-center">
		<div
			class="absolute top-0 left-0 w-full h-full z-0"
		>
			<div class="relative w-full h-full overflow-hidden">
				<div
					class="absolute top-0 left-0 w-full h-full bg-cover bg-center z-0"
					style="background-image: url('images/apartment/3.jpg');"
				></div>

				<div
					class="absolute top-0 left-0 w-full h-full bg-charcoal opacity-40 z-10"
				></div>
			</div>
		</div>

		<div class="w-screen h-screen grid z-20">
			<div class="relative w-fit h-fit mt-auto mx-auto text-center">
				<span class="block font-display italic font-medium text-white text-clamp-md drop-shadow-[1px_1px_2px_rgba(0,0,0,0.5)]">
					House
				</span>
				<span class="block font-display uppercase tracking-widest text-clamp-lg font-medium text-white drop-shadow-[1px_1px_2px_rgba(0,0,0,0.5)]">
					Ana
				</span>
				<span class="block font-display italic font-medium text-white text-clamp-sm drop-shadow-[1px_1px_2px_rgba(0,0,0,0.5)]">
					Kršan, Istria
				</span>
			</div>

			<div class="flex flex-col justify-center items-center w-fit h-fit gap-2 m-auto">
				<div class="flex justify-center items-center gap-4 h-12 scale-[0.7] md:scale-[0.8] lg:scale[1]">
					<div class="flex justify-center items-center gap-2 h-full">
						<ProfileIcon :width="40" :height="40" color="white" />

						<span class="text-white text-2xl font-display">
							{{ infoConfig.guests }} + {{ infoConfig.extraGuests }}
						</span>
					</div>
					<div class="h-full grid place-content-center px-4 border-l border-r border-white">
						<GardenIcon :width="34" :height="34" color="white" />
					</div>
					<div class="h-full grid place-content-center pr-4 border-r border-white">
						<PawIcon :width="34" :height="34" color="white" />
					</div>
					<div class="h-full grid place-content-center pl-1">
						<GrillIcon :width="30" :height="41" color="white" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import ProfileIcon from './icons/ProfileIcon.vue';
import GardenIcon from './icons/GardenIcon.vue';
import GrillIcon from './icons/GrillIcon.vue';
import PawIcon from './icons/PawIcon.vue';

import { infoConfig } from '@/assets/config/infoConfig';

export default {
	name: 'LandingPage',
	components: {
		ProfileIcon,
		GardenIcon,
		GrillIcon,
		PawIcon,
	},
	setup() {
		return {
			infoConfig,
		};
	},
}
</script>
